// @flow

import { arquivoNav } from '../arquivo_path';

/** Função chamada quando a modal for fechada */
export function handleModalClose() {
  arquivoNav.listagem();
}
